const o = () => null;
export {
  o as noop
};
